import {useController} from 'react-hook-form';
import {useMemo} from 'react';
import {useMasterData} from '../../../../../components/master-data-provider';
import {Pulldown} from '@/features/company-registration/components/pulldown';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';

export function IpoKbnField() {
  return (
    <FormField.Root name='companyInfo.ipoKbn'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {control, isError} = useFormField();
  const {
    field: {name, onChange, value, ref},
  } = useController({control, name: 'companyInfo.ipoKbn'});
  const {
    trigger,
    formState: {isSubmitted},
  } = useCompanyRegistrationFormContext();

  const masterData = useMasterData();
  const options = useMemo(
    () =>
      masterData?.ipoKbn.map((k) => ({
        key: k.name,
        value: k.id.toString(),
      })) ?? [],
    [masterData?.ipoKbn],
  );

  const handleOnChange = (newValue: string) => {
    onChange(newValue);
    if (isSubmitted) void trigger('companyInfo.securityCode');
  };

  return (
    <Pulldown
      ref={ref}
      id={name}
      name={name}
      placeholder='選択してください'
      value={value}
      options={options}
      error={isError}
      aria-describedby={`${name}-error`}
      style={{width: 187}}
      aria-label='上場区分'
      onChange={handleOnChange}
    />
  );
}
